import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../../constants/styles';
let {
  ERROR_BACKGROUND_COLOR,
  ERROR_BORDER_COLOR,
  ERROR_TEXT_COLOR
} = constants;

let styles = {
  results: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    padding: 28
  },
  field: {
    width: '50%',
    fontWeight: 500
  },
  value: {
    width: '50%',
    marginBottom: 5
  },
  errors: {
    overflowY: 'auto',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    maxHeight: 250,
    marginTop: 10,
    padding: 10,
    border: `1px solid ${ERROR_BORDER_COLOR}`,
    backgroundColor: ERROR_BACKGROUND_COLOR,
    color: ERROR_TEXT_COLOR
  },
  errorHeader: {
    fontWeight: 500
  },
  errorLine: {
    flexShrink: 0,
    width: 40,
    marginRight: 5
  },
  errorText: {
    width: 'calc(100% - 45px)',
    marginBottom: 5
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/bulkupload/bulkuploadresults/BulkUploadResults.styles.js